module.exports = __webpack_public_path__ + "static/media/7.386fb5de.jpg";